export default {
  admin: "Administrador",
  global_manager: "Gerente Geral",
  local_manager: "Gerente Local",
  pos_employee: "Caixa de Loja",
  salesman: "Vendedor"
};



// WEBPACK FOOTER //
// ./src/core/enum/role-types.enum.js